import { render, staticRenderFns } from "./VideoConsultationComponent.vue?vue&type=template&id=7db493fc&scoped=true"
import script from "./VideoConsultationComponent.vue?vue&type=script&lang=js"
export * from "./VideoConsultationComponent.vue?vue&type=script&lang=js"
import style0 from "./VideoConsultationComponent.vue?vue&type=style&index=0&id=7db493fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db493fc",
  null
  
)

export default component.exports